import { AxiosInstance } from 'axios';
import { UserService } from 'services/Settings/ACL';

export interface UserServiceModel {
  getAll: ReturnType<typeof UserService.getAll>;
  getAllUsersByHotel: ReturnType<typeof UserService.getAllUsersByHotel>;
  getById: ReturnType<typeof UserService.getById>;
  create: ReturnType<typeof UserService.create>;
  update: ReturnType<typeof UserService.update>;
  remove: ReturnType<typeof UserService.remove>;
  updatePassword: ReturnType<typeof UserService.updatePassword>;
  updatePin: ReturnType<typeof UserService.updatePin>;
  checkUserPin: ReturnType<typeof UserService.checkUserPin>;
  setUserInactive: ReturnType<typeof UserService.setUserInactive>;
}

export const initUserService = (axios: AxiosInstance): UserServiceModel => ({
  getAll: UserService.getAll(axios),
  getAllUsersByHotel: UserService.getAllUsersByHotel(axios),
  create: UserService.create(axios),
  update: UserService.update(axios),
  remove: UserService.remove(axios),
  getById: UserService.getById(axios),
  updatePassword: UserService.updatePassword(axios),
  updatePin: UserService.updatePin(axios),
  checkUserPin: UserService.checkUserPin(axios),
  setUserInactive: UserService.setUserInactive(axios),
});
